import React, { useEffect, useState } from "react";
import Base from '../../utils/base'
import moment from "moment";

export default function About(props) {
  var base = new Base()
  const momentNow = moment()
  const [beginning, setBeginning] = useState({})
  const [arrFeature, setArrFeature] = useState([
    {
      id: '',
      title: 'Easy & Quick <br/> Booking',
      subtitle: 'Lorem Ipsum is simply dummy text of the printing . ',
      icon: 'icon-booking-1',
    },
    {
      id: '',
      title: 'Best Room <br/> Selection',
      subtitle: 'Lorem Ipsum is simply dummy text of the printing . ',
      icon: 'icon-hotel-1',
    },
    {
      id: '',
      title: 'Close to<br/>Central Surabaya & Airport',
      subtitle: 'Lorem Ipsum is simply dummy text of the printing . ',
      icon: 'icon-booking-1',
    },
    // {
    //   id: '',
    //   title: 'Best Room <br/> Selection',
    //   subtitle: 'Lorem Ipsum is simply dummy text of the printing . ',
    //   icon: 'icon-hotel-1',
    // },
  ])

  useEffect(() => {
		get_data()
    get_beginning_feature_data()
	}, [])

	async function get_data() {
		var response = await base.request(base.url_api + "/info?type=beginning&lang=id")

		if(response != null){
			if(response.status == "success"){
				setBeginning(response.data)
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

  async function get_beginning_feature_data() {
		var response = await base.request(base.url_api + "/feature/beginning/all")

		if(response != null){
			if(response.status == "success"){
				setArrFeature(response.data)
			}
			else
				base.show_error(response.message)
		}
		else
			console.log('Server Error')
	}

  return (
    <div class="about-one" style={{ paddingTop: '10rem', }}>
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="about-one__thumb wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='300ms'>
              <div class="about-one__thumb__item">
                <img src={beginning.url_image1} alt="solinom about" />
                {/* <div class="about-one__thumb__item__element">
                  <img src={"assets/images/shapes/about-shape-1-1.png?rnd=" + momentNow.format('HHmmss')} alt />
                </div> */}
              </div>
              <div class="about-one__thumb__line">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="about-one__thumb__element">
                <div class="about-one__thumb__shape">
                  <div style={{ height: '100%', width: '100%', backgroundImage: 'url(' + beginning.url_image2 + ')', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', }}></div>
                  {/* <img src={beginning.url_image2} alt="solinom image" width="auto" height="100%"/> */}
                </div>
                <div class="about-one__thumb__shape-two">
                  <img src={"assets/images/shapes/about-shape-1-2.png?rnd=" + momentNow.format('HHmmss')} alt />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 mt-5 mt-lg-0">
            <div class="about-one__content wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='300ms'>
              <div class="sec-title text-start">

                {/* <img src="assets/images/shapes/sec-title-s-1.png" alt="WELCOME TO HOTEL" class="sec-title__img" /> */}


                <h6 class="sec-title__tagline bw-split-in-right" style={{ fontSize: '.8rem', }}>{beginning.title}</h6>

                <h3 class="sec-title__title bw-split-in-up text-uppercase" style={{ wordWrap: 'break-word', fontSize: '3.125rem', }}>{beginning.subtitle}</h3>
              </div>
              <p class="about-one__content__text" style={{ fontSize: '1rem', }}>{base.capitalizeFirstLetter(beginning.content)}</p>
              <div class="about-one__feature">
                {
                  arrFeature.map((feature, index) => (
                    <div class="about-one__feature__item " key={index}>
                      <div class="about-one__feature__left d-flex align-items-center" style={{ flex: 1, }}>
                        <img className="about-one__feature__icon position-relative" src={feature.url_image} alt={"About Feature " + index}/>
                        {/* <div class="about-one__feature__icon">
                          <i class={feature.icon}></i>
                        </div> */}
                        <h4 class="about-one__feature__title p-0 mt-0 ms-3" style={{ fontSize: '1.2rem', }}>
                          <a href="/rooms" dangerouslySetInnerHTML={{ __html: feature.title, }}></a>
                        </h4>
                      </div>
                      <p class="about-one__feature__text" style={{ flex: 1, fontSize: '.8rem', }}>{base.capitalizeFirstLetter(feature.subtitle)}</p>
                    </div>
                  ))
                }
              </div>
              {/* <a href="about.html" class="about-one__btn solinom-btn solinom-btn--base">Discover More</a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
